import axios from 'axios';
import { TOKEN } from '../constants';
axios.defaults.baseURL =
    process.env.REACT_APP_NODE_ENV === 'production'
        ? process.env.REACT_APP_API_URL_PROD
        : process.env.REACT_APP_API_URL_DEV;

axios.defaults.headers.common['Accept'] = 'application/json, text/plain, */*';
axios.defaults.headers.post['Content-Type'] = 'application/json';

export const getToken = () => {
    try {
        const res = sessionStorage.getItem(TOKEN);
        return res;
    } catch (error) {}
};
// Add a request interceptor
axios.interceptors.request.use(
    function (config) {
        const token = getToken();

        if (token) {
            // config.headers.common['Authorization'] = 'Bearer ' + token;
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        // if (config && config.url) {
        //     if (config.url.includes('?')) {
        //         config['url'] = `${config.url}&lang_code=${langCode}`;
        //     } else {
        //         config['url'] = `${config.url}?lang_code=${langCode}`;
        //     }
        // }

        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        const { response, ...errorObj } = error;
        if (response.status === 401) {
            // removeUserDataFromBrowserStorage();
            // window.location.replace("/login")
        }
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    }
);

export const login = () => {
    let hotelID = localStorage.getItem('hotel_id');
    const data = {
        hotel_enc_id: hotelID,
        device_type: 'web',
        device_token: 'ok',
        name: 'Guest user',
    };
    return axios.post(`register-guest`, data);
};
export const getMenusItems = (menuid) => {
    const langCode = localStorage.getItem('lang') || 'en';

    return axios.get(
        `restaurant/public/menu/items/${menuid}?lang_code=${langCode}`
        // `restaurant/guest/menu/categorise/${hotelID}/${menuid}?lang_code=${langCode}`
    );
};
export const getMenus = (encID) => {
    const langCode = localStorage.getItem('lang') || 'en';

    let enc_hotel_id = localStorage.getItem('hotel_id');
    return axios.get(
        `restaurant/public/menus/${enc_hotel_id}?lang_code=${langCode}`
    );
};
export const getCategories = (menuid) => {
    const langCode = localStorage.getItem('lang') || 'en';
    return axios.get(
        `restaurant/public/menu/categories/${menuid}?lang_code=${langCode}`
    );
};
export const getItems = (menu_category_id) => {
    const langCode = localStorage.getItem('lang') || 'en';
    return axios.get(
        `restaurant/menu/items/${menu_category_id}?lang_code=${langCode}`
    );
};
export const getHotelDetails = () => {
    const langCode = localStorage.getItem('lang') || 'en';
    const hotelID = localStorage.getItem('hotel_id');
    return axios.get(`guest/hotel/details/${hotelID}?lang_code=${langCode}`);
};

// All below restaurant API's are GET method. No authencation required.

//     Get menus
//         https://test-vserve-api.valet2you.in/api/v5.0.1/restaurant/public/menus/{enc_hotel_id}

//     Get menu categories
//         https://test-vserve-api.valet2you.in/api/v5.0.1/restaurant/public/menu/categories/{menu_id}

//     Get menu sub categories
//         https://test-vserve-api.valet2you.in/api/v5.0.1/restaurant/public/menu/category/sub-categories/{menu_category_id}

//     Get menu items (optional : menu_sub_category_id)
//         https://test-vserve-api.valet2you.in/api/v5.0.1/restaurant/public/menu/items/{menu_category_id}/{menu_sub_category_id?}

//     Get menu sub addons
//         https://test-vserve-api.valet2you.in/api/v5.0.1/restaurant/public/menu/item/subaddons/{menu_item_id}

//     Get menu addons (optional : menu_item_subaddon_id)
//         https://test-vserve-api.valet2you.in/api/v5.0.1/restaurant/public/menu/item/subaddon/addons/{menu_item_id}/{menu_item_subaddon_id?}

//     Get menu item taxes
//         https://test-vserve-api.valet2you.in/api/v5.0.1/restaurant/public/menu/item/taxes/{menu_item_id}

//     Get menu addon taxes
//         https://test-vserve-api.valet2you.in/api/v5.0.1/restaurant/public/menu/addon/taxes/{menu_item_addon_id}
